import { Box, Button, Stack, Drawer } from "@mui/material";
import Iconify from "~src/components/Iconify";
import { useMemo, useState } from "react";
import FilterDrawer from "../FilterDrawer";
import { BestSellingProductsFilters } from "~src/pages/winningProducts/Products";
import { BrandResult } from "../FilterDrawer/SearchBar";
import { SearchBar } from "./SearchBar";

export const Header = ({
  onFiltersUpdated,
  filters,
  selected,
  setSelected,
  handleSearch,
}: {
  onFiltersUpdated: (filters: BestSellingProductsFilters) => void;
  filters?: BestSellingProductsFilters;
  selected: BrandResult[];
  setSelected: React.Dispatch<React.SetStateAction<BrandResult[]>>;
  handleSearch: (searchText?: string | undefined) => void;
}) => {
  const [drawer, setDrawer] = useState<boolean>(false);
  const filtersApplied = useMemo(() => {
    // Count non-search_text filters
    const filterKeys = Object.keys(filters || {}).filter(key => key !== 'search_text');
    return filterKeys.length > 0;
  }, [filters]);

  // Function to clear all filters except search_text
  const handleClearFilters = () => {
    const searchText = filters?.search_text;
    onFiltersUpdated(searchText ? { search_text: searchText } : {});
    setSelected([]);
  };

  return (
    <>
      <Drawer anchor={"right"} open={drawer} onClose={() => setDrawer(false)}>
        <FilterDrawer
          filters={filters}
          closeDrawer={() => setDrawer(false)}
          onComplete={(filters) => {
            setDrawer(false);
            onFiltersUpdated(filters);
          }}
          onCancel={() => setDrawer(false)}
          selected={selected}
          setSelected={setSelected}
        />
      </Drawer>
      <Box
        sx={{
          display: "flex",
          justifyContent: {
            md: "space-between",
            xs: "center",
          },
          flexDirection: {
            md: "row",
            xs: "column",
          },
          alignItems: {
            md: "center",
            xs: "flex-start",
          },
          my: 3,
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
              md: 600,
            },
            mb: {
              xs: 2,
              md: 0,
            },
          }}
        >
          <SearchBar 
            onSearch={handleSearch} 
            initialSearchText={filters?.search_text}
          />
        </Box>

        <Stack direction="row" spacing={1}>
          {filtersApplied && (
            <Button
              variant={"outlined"}
              startIcon={<Iconify icon="uil:times-circle" />}
              sx={{
                borderRadius: "100px",
                height: "40px",
              }}
              onClick={handleClearFilters}
            >
              Clear all
            </Button>
          )}
          <Button
            variant={filtersApplied ? "contained" : "outlined"}
            startIcon={<Iconify icon="ion:filter" />}
            sx={{
              borderRadius: "100px",
              height: "40px",
            }}
            onClick={() => {
              setDrawer(true);
            }}
          >
            Filters
          </Button>
        </Stack>
      </Box>
      {/* <FilterChips filters={filters} onFilterUpdate={onFiltersUpdated} /> */}
    </>
  );
};
